import { axiosAuth } from '../helper/axios-auth';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { AccessToken } from 'cdfdigital-common/src/models/AccessToken';

type AuthInfoState = {
  data: {
    identifier: string;
    email: string;
    recaptchaToken?: string;
    lastName?: string;
  };
};

export const getAccessToken = createAsyncThunk(
  `access-token/generate`,
  async (
    { data: { identifier, email, recaptchaToken, lastName } }: AuthInfoState,
    { rejectWithValue, getState },
  ) => {
    try {
      const { labelReducer } = getState() as any;
      const axios = await axiosAuth();
      const idParam = 'NR_CPF';
      const response = await axios.post<AccessToken>(
        '/auth/generate-access-token',
        {
          [idParam]: identifier,
          ID_CLIENTE_CORPORATIVO: labelReducer.ID_CLIENTE_CORPORATIVO,
          NR_EMAIL: email,
          label: labelReducer.slug,
          platform: 'web',
          recaptchaToken,
          LAST_NAME: lastName,
        },
      );
      return response.data;
    } catch (e) {
      const { labelReducer } = getState() as any;
      const error = accessTokenError(e as AxiosError, labelReducer.slug);
      return rejectWithValue(error);
    }
  },
);

interface ErrorMessage {
  message?: string;
  status?: number | null;
}

const accessTokenError = (axiosError: AxiosError, label: string): ErrorMessage => {
  const genericError = 'Login Inválido! Tente novamente.';
  const networkErrorMessage = 'Verifique a sua conexão e tente novamente.';
  const fallbackMessage = 'Ocorreu um erro. Tente novamente mais tarde.';

  const customErrors: Record<string, string> = {
    magalu: 'VERIFIQUE SE O CPF DO TITULAR DO SERVIÇO E O TELEFONE FORAM PREENCHIDOS CORRETAMENTE OU CLIQUE EM CENTRAL DE ATENDIMENTO E FALE COM UM DE NOSSOS ESPECIALISTAS',
    pernambucanas: 'Login inválido! Entre em contato no 0800 718 9007 para atualizar seu cadastro',
  };

  const labelMessage = customErrors[label] || genericError;

  const errors: Record<number, string> = {
    401: labelMessage,// CPF não existe ou sem contrato
    403: 'ReCAPTCHA inválido. Por favor, tente novamente.', // reCAPTCHA inválido
    500: 'Erro interno no servidor. Por favor, tente novamente mais tarde.',
    402: 'O seu contrato não inclui acesso ao aplicativo.',// Sem produtos permitidos
    406: labelMessage,// Chave inválida
    409: 'Chave de acesso inválida ou expirada.',// Pincode já usado
    422: labelMessage,// Cadastro inválido, retornado pelo Taki
    429: 'Muitas tentativas. Tente novamente mais tarde.',// Muitas requisições
  };

  if (axiosError.response) {
    const status = axiosError.response.status;
    return {
      message: errors[status],
      status,
    };
  }

  if (axiosError.message === 'Network Error') {
    return {
      message: networkErrorMessage,
      status: null,
    };
  }

  return {
    message: fallbackMessage,
    status: 500,
  };
};
